module.exports = __webpack_public_path__ + "img/Accounting.27db7218.jpg";